import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getPortalPaths, type PortalMode } from '@utils/portalPaths';

const viewMap: Record<string, 'browse' | 'submissions' | 'leaderboard'> = {
  submit: 'browse',
  results: 'submissions',
  leaderboard: 'leaderboard',
};

interface ContestRankingLegacyRedirectProps {
  portalMode?: PortalMode;
}

/** Redirect legacy /ranking-evaluation/contest URLs to the dedicated contest section. */
const ContestRankingLegacyRedirect: React.FC<ContestRankingLegacyRedirectProps> = ({ portalMode = 'player' }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const sport = params.get('sport') || 'Badminton';
  const view = viewMap[params.get('view') || ''] || 'browse';
  const paths = getPortalPaths(portalMode);
  const target = paths.contestSport(sport, 'all', view);
  const taskId = params.get('taskId');
  const suffix = taskId ? `${target.includes('?') ? '&' : '?'}taskId=${encodeURIComponent(taskId)}` : '';
  return <Navigate to={`${target}${suffix}`} replace />;
};

export default ContestRankingLegacyRedirect;
